import { inject, Injectable, signal, TemplateRef } from '@angular/core';
import { LoggerService } from '@shared/services/logger.service';
import { PageState } from '@shared/interfaces/page-state.interface';
import { PAGE_STATE } from '@shared/enums/page-state.enum';

@Injectable({
  providedIn: 'root'
})
export class PageService implements PageState {
  private logger = inject(LoggerService);

  hasBreadcrumbs = signal<boolean | null>(true);

  tplHeader = signal<TemplateRef<any> | null>(null);

  tplActions = signal<TemplateRef<any> | null>(null);

  tplKPIs = signal<TemplateRef<any> | null>(null);

  constructor() {
    this.logger.debug(this.constructor.name);
  }

  reset(value: PAGE_STATE | PAGE_STATE[] = PAGE_STATE.ALL): void {
    if (!Array.isArray(value)) value = [value];
    if (value.includes(PAGE_STATE.ALL)) {
      this.tplHeader.set(null);
      this.tplActions.set(null);
      this.tplKPIs.set(null);
    }
    if (value.includes(PAGE_STATE.HEADER)) {
      this.tplHeader.set(null);
    }
    if (value.includes(PAGE_STATE.ACTIONS)) {
      this.tplActions.set(null);
    }
    if (value.includes(PAGE_STATE.KPIS)) {
      this.tplKPIs.set(null);
    }
  }
}
